import {Zero, Logger, Components} from 'Zero';
import $ from 'Vendor/jquery';

const Log = new Logger("Zero/StoreLocator/ZFilters");

export default class ZFilters extends Components {

  get Selectors() {
    return {
      FiltersCounter: '#filters-counter,[data-filters-counter]',
      ApplyFiltersBtn: '.apply-filter-btn',
      ClearFiltersBtn: '.clear-filter-btn',
      FilterInput: '.mm_sl-filter-input',
      FilterFacet: '.mm_sl-filter-facet',
      FilterCloseBtn: '.close-filter'
    }
  }

  get react() {
    return {
      calculateFilters: function() {
        var filters = Zero.$state.StoreLocator.Filters;
      }
    }
  }

  constructor(element) {
    super(element);

    this.FiltersCounter = $('body').find(this.Selectors.FiltersCounter);
    this.FilterInput = $('body').find(this.Selectors.FilterInput);
    this.FilterFacet = $('body').find(this.Selectors.FilterFacet);
    this.FilterCloseBtn = $('body').find(this.Selectors.FilterCloseBtn);
    this.ApplyFiltersBtn = $('body').find(this.Selectors.ApplyFiltersBtn);
    this.ClearFiltersBtn = $('body').find(this.Selectors.ClearFiltersBtn);
    this.onFilterSelection();
    this.applyFilters();
    this.calculateFilters();
    this.onFilterClose();
    this.showFiltersOnLoad();
    this.applyFiltersBtn();
    this.clearFiltersBtn();
    if(window.matchMedia("(max-width: 768px)").matches) {
      this.mobileFilterSelect();
    }
  }


  onFilterSelection() {
    this.FilterInput.on("change.filters", (e) => {
      e.preventDefault();
      $(".js-prefilter").attr('data-prefilter', '');
      this.onLabelCreation();
      this.displayFilterButtons();
      this.applyFilters();
    });
  }

  onFilterClose() {
    this.FilterCloseBtn.on('click', (e) => {
      let ctx = this;
      this.FilterInput.each(function () {
        //finds filter corresponding to button
        if ($(e.target).attr('data-close-filter') === this.id) {
          $(this).prop('checked', false);
          $(this).trigger('change.filters');
        }
      });
    });
  }

  onLabelCreation() {
    let filters = document.querySelectorAll('.mm_sl-filter-input:checked');
    let filtersCounter = this.FiltersCounter;

    if(filters.length > 0) {
      filtersCounter.addClass('show');
      filtersCounter.html(`(${filters.length})`);
    } else {
      filtersCounter.removeClass('show');
      filtersCounter.html(``);
    }
  }


  displayFilterButtons() {
    let filters = this.FilterInput;
    let filterBtns = $('body').find('.feature-container');
    $(filters).each(function (index) {
      let fltr = this;
      $(filterBtns).each(function () {
        let btn = this;
        //finds button corresponding to filter
        if (fltr.id === $(btn).attr('data-btn-filter')) {
          //ends prev. animation
          $(btn).finish();
          //shows/hides corresponding button
          if (fltr.checked === true) {
            $(btn).css('display', 'inline-flex');
            $(btn).animate({height: 20}, '400');
          } else {
            $(btn).animate({height: 0}, '400', function () {
              $(this).css('display', 'none');
            });
          }
        }
      });
    });
  }


  applyFilters() {
    const filterArr = this.element.serializeArray();
    let resultArr = {};

    for(let object of filterArr) {
      let name = object.name;
      let value = object.value;

      if(resultArr[name]){
        if( ! $.isArray(resultArr[name]) ) {
          resultArr[name] = [resultArr[name]];
        }
        resultArr[name].push(value);

      } else {
        resultArr[name] = value;
      }
    }

    Zero.$state.StoreLocator.Filters = resultArr;
    return resultArr;
  }

  showFiltersOnLoad() {
    var prefilters = Zero.$state.StoreLocator.Filters;
    if(prefilters) {
      this.displayFilterButtons();
      this.onLabelCreation();
    }
  }

  applyFiltersBtn() {
    this.ApplyFiltersBtn.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  clearFiltersBtn() {
    this.ClearFiltersBtn.on('click', (e) => {
      e.preventDefault();
      this.FilterFacet.each(function () {
        $(this).removeClass('selected');
        $(this).find('input').prop('checked', false);
        $(this).find('input').trigger('change.filters');
      });
      this.applyFilters();
    });
  }

  mobileFilterSelect() {
    this.FilterFacet.each(function (index, element) {
      $(element).on('click', (e) => {
        const elInput = $(element).find('input');
        if (!elInput) return;
        elInput.prop('checked', !elInput.prop('checked'));
        elInput.trigger('change.filters');
        $(element).toggleClass('selected', elInput.prop('checked'));
      });
    });
  }

}

export {
  ZFilters
}
